export default __webpack_public_path__ + "static/media/NOMOR 1 BENAR.f8966804.png";